(function($) {

  var iso = $('.iso').imagesLoaded(function() {
    iso.isotope({
      itemSelector: '.iso-post',
      layoutMode: 'fitRows',
        percentPosition: true,
        fitRows: {
            gutter: 0
        }
    });
  });

    // show if number is greater than 50
    var itemHasClass = function(cl) {
      if ($(this).hasClass(cl)) {
          $(this).addClass('visible');
          return true;
      } else {
          $(this).addClass('hidden');
          return false;
      }
    };


  $.fn.extend({
      hasClasses: function (selectors) {
          var self = this;
          for (var i in selectors) {
              if (selectors[i] != '*' && ! $(self).hasClass(selectors[i]))
                  return false;
          }
          return true;
      }
  });

  // flatten object by concatting values
  function find_filters() {
    var cl = {};

    $('.category-filters li.active').each(function(item) {
      cl[ $(this).data('filter') ] = $(this).data('filter');
    });

    return cl;
  }

  // filter items on button click
  $('.category-filters').on( 'click', 'li', function() {
    var cl,
      filters = $(this).parents('.category-filters').find('li'),
            i = 1,
            extraClass;

    filters.removeClass('active');
    $(this).addClass('active');

    cl = find_filters();

     clicked = true;

      if(cananimate) {
       $('.cat-filters-trigger').removeClass('active');
       cananimate = false;

       $('.filters-wrapper').animate({
          maxHeight: 0
        }, 700, function() {
          // Animation complete.
          cananimate = true;

          iso.isotope({
            filter:  function() {
                $(this).removeClass('iso-main iso-right iso-left iso-full');
                $('.load-more').trigger('click');
                if ($(this).hasClasses(cl) || cl == '*') {
                    if (i == 1) {
                        extraClass = 'iso-main'
                    } else if ( i % 3 == 0) {
                        extraClass = 'iso-right';
                    } else if ( (i-1) % 3 == 0 ) {
                        extraClass = 'iso-full';
                    } else {
                        extraClass = 'iso-left';
                    }

                    $(this).addClass(extraClass);

                    i++;

                    return true;
                }

                return false;
            }
          });

          var filtered = iso.data('isotope').filteredItems.length;

          if (filtered == 0) {
            $('.no-results').removeClass('hidden');
          } else {
            $('.no-results').addClass('hidden');
          }
        });
      }
    });

    // filter slidedown trigger

    var clicked = true;
    var cananimate = true;

    $('.cat-filters-trigger').on( 'click', function() {
      var l = $(this),
          el = l.next('.filters-wrapper').find('ul');

      if(clicked) {

        clicked = false;

        if(cananimate) {
          $(this).addClass('active');
          cananimate = false;

          l.next('.filters-wrapper').animate({
            maxHeight: el.height() + 20
          }, 500, function() {
            // Animation complete.
            cananimate = true;
          });
        }

      } else {

        clicked = true;

        if(cananimate) {
         $(this).removeClass('active');
         cananimate = false;

         l.next('.filters-wrapper').animate({
            maxHeight: 0
          }, 500, function() {
            // Animation complete.
            cananimate = true;
          });
        }
      }

    });

    // products list with owl carousel

    var menuproductslist = $('.product-list');

    // menuproductslist.owlCarousel({
    //   //loop:true,
    //   //nav:true,
    //   dots: true,
    //   //margin:10,
    //   baseClass: "carousel",
    //   itemClass: "carousel-item-wrapper",
    //   navContainerClass: "carousel-nav",
    //   controlsClass: "carousel-controls",
    //   dotClass: "product-group-category",
    //   dotsClass: "product-group-categories",
    //   themeClass: "carousel-theme",
    //   navClass: "[&#x27;carousel-prev&#x27;,&#x27;carousel-next&#x27;]",
    //   autoWidth:true,
    //   dotsSpeed: 500,
    //   smartSpeed: 500,
    //   onInitialized: customPager,
    //   onUpdate: customPager,
    //   dotsContainer: '#product-cat-list',
    //   stagePadding: 50,
    //   center:true,
    //   margin: 3
    // });


      // allow scroll in menu carousel

      var eventLimiter = 210 //miliseconds to wait between two firings
      var fireEvent = true;

      menuproductslist.bind('mousewheel',  '.owl-stage-outer', function (event) {
          event.preventDefault();
         if(!fireEvent) return;

        if (event.deltaY > 0) {
            fireEvent = false;
            menuproductslist.trigger('next.owl');
            setTimeout(function(){ fireEvent = true; }, eventLimiter);

        } else {
            fireEvent = false;
            menuproductslist.trigger('prev.owl');
            setTimeout(function(){ fireEvent = true; }, eventLimiter);
        }
      });



      // custom pagination in menu carousel

      function customPager() {
        $.each($(menuproductslist).find('.carousel-item-wrapper'), function (i) {
          var titleData = jQuery(this).find('ul').attr('title');
          var paginationLinks = jQuery('#product-cat-list .product-group-category span');
          $(paginationLinks[i]).append(titleData);

        });
      }

      // product info accordion


        var productaccordionTitle = $('.mm-product-accordion-title');
        var productaccordionContent = $('.mm-product-accordion-content');

        function close_product_accordion_section() {
          productaccordionTitle.removeClass('active');
          productaccordionContent.slideUp(300).removeClass('active');
        }


        productaccordionTitle.click(function(e) {

          if($(this).hasClass('active')) {
              close_product_accordion_section();
          }else {
            close_product_accordion_section();
            var producttargetContent = $(this).next(productaccordionContent);
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $(producttargetContent).slideDown(400).addClass('active');
          }

          e.preventDefault();
        });


      // inner content accordion


        var accordionTitle = $('.mm-accordion-title');
        var accordionContent = $('.mm-accordion-content');


        open_first_accordion_section();

         function close_accordion_section() {
              accordionTitle.removeClass('active');
              accordionContent.slideUp(300).removeClass('active');
          }

          function open_first_accordion_section(){
            $( ".mm-accordion-title:eq( 0 )" ).addClass('active');
            $( ".mm-accordion-content:eq( 0 )" ).slideDown(400).addClass('active');
          }

          accordionTitle.click(function(e) {



              if($(this).hasClass('active')) {
                  close_accordion_section();
              }else {
                  close_accordion_section();
                  var targetContent = $(this).next(accordionContent);
                  // Add active class to section title
                  $(this).addClass('active');
                  // Open up the hidden content panel
                  $(targetContent).slideDown(400).addClass('active');
              }

              e.preventDefault();
          });


      // carousel in page content


      var contentcarousel = $('.content-carousel');



      contentcarousel.owlCarousel({
        baseClass: "carousel",
        itemClass: "carousel-item-wrapper",
        navContainerClass: "carousel-nav",
        controlsClass: "carousel-controls",
        dotClass: "carousel-dot",
        dotsClass: "carousel-dots",
        themeClass: "carousel-theme",
        loop: true,
        nav: false,
        controls: false,
        margin: 1,
        autoplay:false,
        responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1,
              margin: 0
          },
          // breakpoint from 480 up
          480 : {
              items: 2,
              margin: 1
          }
        },

        onInitialize: function (event) {
          if ($('.content-carousel .content-carousel-item').length <= 1) {
             this.settings.loop = false;
          }
        }
      });

      // Go to the next item
      $('.content-carousel-right').click(function() {
          contentcarousel.trigger('next.owl.carousel');
      })

      // Go to the previous item
      $('.content-carousel-left').click(function() {
          contentcarousel.trigger('prev.owl.carousel');
      })

    // carousel (wide) in page content

      var contentcarouselwide = $('.content-carousel-wide');


      contentcarouselwide.owlCarousel({
        baseClass: "carousel",
        itemClass: "carousel-item-wrapper",
        navContainerClass: "carousel-nav",
        controlsClass: "carousel-controls",
        dotClass: "carousel-dot",
        dotsClass: "carousel-dots",
        themeClass: "carousel-theme",
        loop: true,
        nav: false,
        controls: false,
        margin: 1,
        autoplay:false,
         responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1,
              margin: 0
          },
          // breakpoint from 321 up
          321 : {
              items: 2,
              margin: 1
          },
          992 : {
              items: 4,
              margin: 1
          }
        },

        onInitialize: function (event) {
          if ($('.content-carousel-wide .content-carousel-item').length <= 1) {
             this.settings.loop = false;
          }
        }
      });

      // Go to the next item
      $('.content-carousel-right.wide').click(function() {
          contentcarouselwide.trigger('next.owl.carousel');
      })

      // Go to the previous item
      $('.content-carousel-left.wide').click(function() {
          contentcarouselwide.trigger('prev.owl.carousel');
      })



      // products menu dropdown

       var parent = $('.productsparent');
        var dropdown = $('#products-menu');

        parent.hover(function() {
            dropdown.addClass('shown');
            $('body').addClass('products-menu-shown');

        }, function() {
            dropdown.removeClass('shown');
            $('body').removeClass('products-menu-shown');
        });


        dropdown.hover(function() {
            dropdown.addClass('shown');
            $('body').addClass('products-menu-shown');
        }, function() {
            dropdown.removeClass('shown');
             $('body').removeClass('products-menu-shown');
        });

      // page cover move to content



      $('.next-content-section').click(function() {
           $('html, body').animate({
              scrollTop:  $('#content, #partners-grid, #products-grid').offset().top
          }, 700);
        });

     // page cover owl carousel

      var pagecarousel = $('.pagecarousel');

      pagecarousel.owlCarousel({
        baseClass: "carousel",
        itemClass: "carousel-item-wrapper",
        navContainerClass: "carousel-nav",
        controlsClass: "carousel-controls",
        dotClass: "carousel-dot",
        dotsClass: "carousel-dots",
        themeClass: "carousel-theme",
        navClass: "[&#x27;carousel-prev&#x27;,&#x27;carousel-next&#x27;]",
        animateOut: 'fadeOut',
        loop:true,
        nav:false,
        autoheight: true,
        autoplay: false,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        items: 1,
        onInitialize: function (event) {
          if ($('.carousel .carousel-item').length <= 1) {
            this.settings.loop = false;
            this.settings.dots = false;
            this.settings.mouseDrag = false;
            this.settings.touchDrag = false;
            this.settings.freeDrag = false;
            pagecarousel.closest('.carousel-wrapper').addClass('single-slide');
            }
        },
        onInitialized: playvideo,
        onTranslated: checkvideo
      });

      // Go to the next item
      $('.carousel-next').click(function() {
          pagecarousel.trigger('next.owl.carousel');
      })

      // Go to the previous item
      $('.carousel-prev').click(function() {
          pagecarousel.trigger('prev.owl.carousel');
      })

      // setTimeout( function(){
      //  $('.home .pagecarousel').trigger('next.owl.carousel');
      // }  , 8000 );



      function playvideo() {
        if ($('.pagecarousel video').length > 0) {
          $('.pagecarousel video').get(0).play();
        }
      };

     function checkvideo() {
        if($('.pagecarousel .carousel-item-wrapper.active video').length > 0){
           $('.pagecarousel .carousel-item-wrapper.active video').get(0).play();
        } else{
          //stopvideo();
        }
      }

      function stopvideo() {
        $('.pagecarousel video').get(0).pause();
      }



    // athlete bottom carousel

      var nextathletes = $('.other-athletes-carousel');

      nextathletes.owlCarousel({
        baseClass: "carousel",
        itemClass: "carousel-item-wrapper",
        navContainerClass: "carousel-nav",
        controlsClass: "carousel-controls",
        dotClass: "carousel-dot",
        dotsClass: "carousel-dots",
        themeClass: "carousel-theme",
        navClass: "[&#x27;carousel-prev&#x27;,&#x27;carousel-next&#x27;]",
        loop: true,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayHoverPause:true,
        slideby: 'page',
        responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1
          },
          // breakpoint from 480 up
          480 : {
              items: 2
          },
           // breakpoint from 480 up
          780 : {
              items: 3
          }
        },
        onInitialize: function (event) {
          if ($('.other-athletes-carousel .athlete-item').length <= 1) {
               this.settings.loop = false;
            }
        }
      });

      // Go to the next item
      $('.other-athletes-carousel-next').click(function() {
          nextathletes.trigger('next.owl.carousel');
      })

      // Go to the previous item
      $('.other-athletes-carousel-prev').click(function() {
          nextathletes.trigger('prev.owl.carousel');
      })


    // mobile nav

    $(document).ready(function(){
      var mobileproductsparent = $('#menu-mobile-primary-navigation .mobile-products-parent');
      var mobileproductscarousel = $('#mobile-menu-products')
      var mobilesearchparent = $('#menu-mobile-primary-navigation .mobile-search-parent');
      var mobilesearchform = $('#mobile-menu-search')

      mobileproductsparent.append(mobileproductscarousel);
      mobilesearchparent.append(mobilesearchform);
      mobileproductscarousel.css('display', 'block');
    });

    var overlayvisible = false;

    $('.mobile-nav-toggle').on( 'click', function() {
      $('body').toggleClass('mobile-menu-active');
      $(this).toggleClass('active');

      if(overlayvisible){
        overlayvisible = false;

      } else {
        overlayvisible = true;

      }
    });
/*
    $('#menu-mobile-primary-navigation .menu-item-has-children:not(.mobile-products-parent) > a').on('click', function(e){
      e.preventDefault();
      var currentitem = $(this).parent();
      var currenttoppos = 0;

      if(currentitem.hasClass('opened')){
         currentitem.removeClass('opened');
         currenttoppos = 0;
      } else {

         currentitem.addClass('opened');

        currenttoppos = $(this).position().top;
        $(this).parent('.nav').delay(300).animate({
          scrollTop:  currenttoppos
        }, 700);

      }

    });
*/
$('#menu-mobile-primary-navigation .mobile-products-parent a, #menu-mobile-primary-navigation .mobile-search-parent a').on('click', function(e){
      var currentitem = $(this).parent();
      //var currenttoppos = 0;

      if(currentitem.hasClass('opened')){
         currentitem.removeClass('opened');
         //currenttoppos = 0;
      } else {
        currentitem.addClass('opened');
        currentitem.siblings().removeClass('opened');
        //currenttoppos = $(this).position().top;
      }

       if($(this).parent().hasClass("menu-item-has-children")){
           e.preventDefault();
       } else {
           
       }
        //e.preventDefault();
    });

    // mobile nav products carousel

    var mobilemenuproductslist = $('.mobile-products-list');

    mobilemenuproductslist.owlCarousel({
        loop:true,
        dots: false,
        nav: false,
        baseClass: "carousel",
        itemClass: "carousel-item-wrapper",
        navContainerClass: "carousel-nav",
        controlsClass: "carousel-controls",
        themeClass: "carousel-theme",
        navClass: "[&#x27;carousel-prev&#x27;,&#x27;carousel-next&#x27;]",
        margin: 0,
        stagePadding: 0,
        responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1
          },
          // breakpoint from 321 up
          321 : {
              items: 2
          },
           // breakpoint from 620 up
          620 : {
              items: 3
          }
        },
        slideBy: 'page',
        onInitialize: function (event) {
          if ($('.mobile-products-list .mobile-menu-product-item').length <= 1) {
             this.settings.loop = false;
          }
        }
        //merge:true,
        //navSpeed: 10000,
        //fluidSpeed: 10000,
        //autoplaySpeed: 10000,
        //dragEndSpeed: 10000,
        //mergeFit: true,


      });

      // Go to the next item
      $('.mobile-products-next').click(function() {
          mobilemenuproductslist.trigger('next.owl.carousel');
      })

      // Go to the previous item
      $('.mobile-products-prev').click(function() {
          mobilemenuproductslist.trigger('prev.owl.carousel');
      });


  // content custom carousel

      var customcarousel = $('.content-custom-carousel');
      var desktopnum = 5;

      customcarousel.owlCarousel({
        baseClass: "carousel",
        itemClass: "carousel-item-wrapper",
        navContainerClass: "carousel-nav",
        controlsClass: "carousel-controls",
        dotClass: "carousel-dot",
        dotsClass: "carousel-dots",
        themeClass: "carousel-theme",
        loop: false,
        nav: false,
        dots: false,
        autoplay: false,
        slideby: 'page',
        responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1
          },
          // breakpoint from 480 up
          480 : {
              items: 2
          },
          620: {
            items: 3
          },
           // breakpoint from 480 up
          780 : {
              items: 5
          }
        }

      });

      // Go to the next item
      $('.content-custom-carousel-right').click(function() {
          customcarousel.trigger('next.owl.carousel');
      })

      // Go to the previous item
      $('.content-custom-carousel-left').click(function() {
          customcarousel.trigger('prev.owl.carousel');
      });



    // reset on window resize

    $( window ).resize(function() {

      if(overlayvisible) {
        $('body').removeClass('mobile-menu-active')
        $('.mobile-nav-toggle').removeClass('active');
        overlayvisible = false;
      }
    });

    //  full-width video wrapper, stop video

     $('#video-modal, .slide-video-modal, .video-block').on('hidden.bs.modal', function (e) {
        var currentplayer = $(this).find('iframe');
        var currenturl = currentplayer.attr("src");
        var  baseurl = currenturl.replace('?autoplay=1', '');
        currentplayer.attr("src", baseurl);
      });

    // stop carousel on modal open

       var targetvideoiframe;
       var  targetvideosrc;


      $('.video-trigger').click(function(){

       // auto start video
       var triggertarget = $(this).data("target");
       targetvideoiframe = $(triggertarget + ' iframe');
       targetvideosrc = targetvideoiframe.attr("src");
       var targetvideosrcauto = targetvideosrc + "?autoplay=1";

       targetvideoiframe.attr('src', targetvideosrcauto);

      });

      /*$('.modal .close').click(function() {
        // change auto start back to normal
        //targetvideoiframe.attr('src', targetvideosrc);
      });*/


    // partners page additional info on click

    var $cell = $('.partner-col');

      $cell.find('.partner-content-trigger').click(function() {
        var $thisCell = $(this).closest('.partner-col');
        var thisHeight = $thisCell.height();

        if ($thisCell.hasClass('is-collapsed')) {
          $cell.not($thisCell).find('.expand-close').trigger('click');
          $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed');
          $thisCell.removeClass('is-collapsed').addClass('is-expanded');

          $thisCell.children('.partner-additional-info').animate({
            maxHeight: 800
          }, 400, function() {
            // Animation complete.
             var offsetval = $thisCell.offset().top;
            $('html, body').animate({
              scrollTop: offsetval
            }, 600)
          });

        } else {
          $thisCell.removeClass('is-expanded').addClass('is-collapsed');

        }
      });

      $cell.find('.expand-close').click(function() {
        var $thisCell = $(this).closest('.partner-col');
        $thisCell.children('.partner-additional-info').animate({
          maxHeight: 0
        }, 400, function() {
          // Animation complete.
          $thisCell.removeClass('is-expanded').addClass('is-collapsed');
        });
      });


      // full page slider

     $('document').ready(function(){

        //console.log($('.scroll-sections-wrap').height());

        var vpw = $(window).width();
        var vph = $(window).height();
        var verticaldotswrapper = $('.vertical-dots-nav');
        var scrollsection = $('.scroll-section');
        var firstsection = scrollsection.first();
        var scrolltarget = firstsection;
        var scrollstage = $('.scroll-sections-wrap');
        var sectionheight = vph;
        var nextsection = $('.next-scroll-section');
        var sectionnumber = scrollsection.length - 1;
        var currentslide = 1;
        var index = 0;
        var title = 0;
        var targetindex = 0;
        var resizetimer = 0;
        var closesttarget = 0;

        resetsectionheight();

        scrollsection.each(function(){
          index = $(scrollsection).index(this);
          title = $(this).data('section-title');
          $(this).attr('data-section-index', index);


          verticaldotswrapper.append('<div class="vertical-scroll-dot" data-dot-index="0"><div class="scroll-dot-title">' + title + '</div></div>');

        })

        $('.vertical-scroll-dot').first().addClass('active');

        $('.vertical-scroll-dot').each(function(){
          index = $('.vertical-scroll-dot').index(this);
          $(this).attr('data-dot-index', index);
        });

        $('.vertical-scroll-dot').click(function(){

            targetindex = $(this).data('dot-index');

            scrolltarget = $('[data-section-index="' + targetindex + '"]')
            gotonextsection();

        });


        nextsection.click(function(){
          scrolltarget = $(this).parent().parent().next(scrollsection);
          gotonextsection();
        })

        scrollsection.bind('inview', function (event, visible, topOrBottomOrBoth) {
          if (visible == true) {
            // element is now visible in the viewport

             $(this).addClass('active');
              $('.vertical-scroll-dot').removeClass('active');
              currentindex = $(this).data('section-index');
              $('[data-dot-index="' + currentindex + '"]').addClass('active');

              $(this).find('.num').each(function () {
                var $this = $(this);


                $({countNum: 0}).animate({countNum: $this.html()}, {
                  duration: 2000,
                  easing:'linear',
                  step: function() {
                    // What todo on every count
                    $this.text(Math.floor(this.countNum));
                  },
                  complete: function() {
                    $this.text(Math.ceil(this.countNum));
                  }
                });

              });

          } else {
            // element has gone out of viewport
            $(this).removeClass('active');
          }
        });



        $(window).resize(function() {
          if ($('body').hasClass('page-template-page-scroll')){
             clearTimeout(resizetimer);
            resizetimer = setTimeout(doneResizing, 300);
          }
        });

        function doneResizing(){
          vpw = $(window).width();
          vph = $(window).height();


          resetsectionheight();
          /*closesttarget = $('.scroll-section.active').first();

           $('html, body').animate({
              scrollTop:  closesttarget.offset().top
          }, 700);*/

          $(window).scroll();
        }

        function resetsectionheight(){
          sectionheight = vph;
          scrollsection.each(function(){
            $(this).css('min-height', sectionheight);
          })

        }

        function gotonextsection(){
           $('html, body').animate({
              scrollTop:  scrolltarget.offset().top
          }, 700);
        }

      });


      // custom page button reveal text

      var revealbutton = $('.reveal-button');
      var revealtargetnum = 0;
      var revealtarget = 0;
      var selfnum = 0;
      var canreveal = true;


      revealbutton.bind('tap click', function(){


        if(canreveal == true ){

          revealbutton.not(this).removeClass('active');
          $(this).addClass('active');
          selfnum = revealbutton.index(this);

          revealtargetnum = selfnum;

          $('.reveal-content-box').not(':eq(' + revealtargetnum + ')').removeClass('revealed');

          canreveal = false;

          window.setTimeout( showrevealcontent, 800 );
        }


      });


      function showrevealcontent(){
        $('.reveal-content-box:eq(' + revealtargetnum + ')').addClass('revealed');
        canreveal = true;
      }


        // fixed navigation

        // Hide Header on on scroll down

        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('.navbar-mm').outerHeight();

        $(window).scroll(function(event){
            didScroll = true;
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

      function hasScrolled() {
          var st = $(this).scrollTop();

          // Make sure they scroll more than delta
          if(Math.abs(lastScrollTop - st) <= delta)
              return;

          if (st > 0) {
             $('body').addClass('nav-moved');
          } else {
            $('body').removeClass('nav-moved');
          }

          // If they scrolled down and are past the navbar, add class .nav-up.
          // This is necessary so you never see what is "behind" the navbar.
          if (st > lastScrollTop && st > navbarHeight){
              // Scroll Down
              if(! $('body').hasClass('products-menu-shown')){
                $('body').removeClass('nav-down').addClass('nav-up');
              }
          } else {
              // Scroll Up
              if(! $('body').hasClass('products-menu-shown')){
                if(st + $(window).height() < $(document).height()) {
                    $('body').removeClass('nav-up').addClass('nav-down');
                }
              }
          }

          lastScrollTop = st;
      }

      // load more

    $(document).on('click', '.load-more', function(e) {
        e.preventDefault();

        var link = $(this),
            offset = link.data('offset'),
            limit = link.data('limit'),
            i = link.data('i'),
            data = {
                action: 'mm_loader',
                offset: offset,
                i: i,
                post_type: link.data('post_type'),
                category_name: $('#category-filters li.active').data('filter'),
                template: link.data('template')
            };

        link.text('Please wait ...');

        $.post('/wp-admin/admin-ajax.php', data, function(response) {
            if (response) {
                var added = $.parseHTML(response);
                iso.append(added).isotope('appended', added);
            }
        });

        link.text('+');
        //link.data('offset', offset + limit).data('i', i + limit).text('Load more');
    });

    $('.product-slider-title').on('click', function(e) {
      var item = $(this),
          lis = $('.product-variants'),
          el = lis.find('li').length;

          $('.buy-online-options').removeClass('open').css({'max-height': 0});
          $('.buy-online-title').removeClass('active');

          if (lis.hasClass('open')) {
            lis.removeClass('open').animate({'max-height': 0}, 350);
          } else {
            lis.addClass('open').animate({'max-height': el * 100}, 350);
          }
          item.toggleClass('active');
    });

    $('.buy-online-title').on('click', function(e) {
      var item = $(this),
          lis = $(this).parents('.buy-online').find('.buy-online-options'),
          el = lis.find('li').length;

          $('.product-variants').removeClass('open').css({'max-height': 0});
          $('.product-slider-title').removeClass('active');

          if (lis.hasClass('open')) {
            lis.removeClass('open').animate({'max-height': 0}, 350);
          } else {
            lis.addClass('open').animate({'max-height': el * 100}, 350);
          }
          item.toggleClass('active');
    });

    $('.flavor-slider').on('click', function(e) {
      e.preventDefault();

      var slider = $(this),
          op = slider.hasClass('up') ? slider.parents('span').find('i.down') : slider.parents('span').find('i.up'),
          w = slider.parents('.product-slider'),
          t = parseInt(w.data('top'), 10),
          b = parseInt(w.data('bottom'), 10);

      if (slider.hasClass('disabled')) {
        return false;
      }

      if (slider.hasClass('up') && b > 0) {
        $('.product-variants li.active').animate({
          opacity: 0,
          height: 0,
        }, 350, function() {
          w.data('top', t + 1);
          w.data('bottom', b - 1);
          op.removeClass('disabled');
          if (b == 1) {
            slider.toggleClass('disabled');
          }
          $(this).removeClass('active').next().addClass('active').find('img').first().trigger('click');
        });
      } else {
        $('.product-variants li.active').prev().animate({
          opacity: 1,
          height: 80,
        }, 350, function() {
          w.data('top', t - 1);
          w.data('bottom', b + 1);
          op.removeClass('disabled');
          if (t == 1) {
            slider.toggleClass('disabled');
          }
          $(this).next().removeClass('active');
          $(this).addClass('active').find('img').first().trigger('click');
        });
      }

    });

    $('.product-variants li img').on('click', function() {

      var img = $(this),
          src = img.data('image'),
          id = img.data('id'),
          url = img.data('url'),
          target = $('#product-image img'),
          orig = target.attr('src'),
          l = $(this).parents('ul').find('li'),
          acl = $(this).parents('li'),
          stores = ['amazon', 'costco', 'walmart', 'target', 'bb', 'vs', 'gnc'],
          storeLink,
          buyBtns = false;

        if (l.length == 0) return;

      $('.nutritional').show();

      stores.forEach(function(store) {
        storeLink = img.data(store);
        if (storeLink) {
          $('.' + store + '-btn').attr('href', storeLink).removeClass('hidden').addClass('visible');
          buyBtns = true;
        } else {
          $('.' + store + '-btn').attr('href', storeLink).addClass('hidden').removeClass('visible');
        }
      });

      if (buyBtns) {
        $('.buy-online').addClass('visible').removeClass('hidden');
      } else {
        $('.buy-online').addClass('hidden').removeClass('visible');
      }

      if (src == orig) {
        return false;
      }

		
		
      if (history && history.pushState){
     //   history.pushState(null, null, url);
		  window.location.href = url;
      }

      $('.product-slider-title').removeClass('active');
      $('.product-variants').removeClass('open').animate({'max-height': 0}, 350);

      l.removeClass('active');
      acl.addClass('active');

      target.fadeOut(300, function() {
        img.parents('ul.product-variants').data('id', id);
        target.removeAttr('srcset');
        target.attr('src', src).removeAttr('width').removeAttr('height').fadeIn(500);

        var bis = $('#variant-benefits-' + id).find('li').length;
        $('.benefits .nutinfo-table, .benefits .blm').addClass('hidden');
        if (bis > 0) {
            $('.benefits-title, .benefits').removeClass('hidden');
            $('#variant-benefits-' + id).removeClass('hidden');
            $('#blm-' + id).removeClass('hidden');
        } else {
            $('.benefits-title, .benefits').addClass('hidden');
        }

        var uis = $('#variant-usage-' + id).find('li').length;
        $('.usage .nutinfo-table').addClass('hidden');
        if (uis > 0) {
          $('.usage-title, .usage').removeClass('hidden');
          $('#variant-usage-' + id).removeClass('hidden');
        } else {
          $('.usage-title, .usage').addClass('hidden');
        }

        $('.icons ul:visible').addClass('hidden');
        $('#variant-icons-' + id).removeClass('hidden');
      });

    });

   /* $('.btn-ni').on('click', function(e) {
      e.preventDefault();

      var id = $(this).hasClass('btn-variant-ni') ? $(this).data('id') : $('ul.product-variants').data('id'),
          data = {
              action: 'mm_nutrition',
              id: id
          };

      $.post('/wp-admin/admin-ajax.php', data, function(response) {
        $('#modal-ni').html(response).modal();
      });
    });
	*/

})(jQuery);
